import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`data`}</strong><br />{`any`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Represents the current state of the simulation.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`tick`}</strong><br />{`integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A measure of time in the simulation. Each time the simulation updates, ticks increases by one.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`params`}</strong><br />{`Object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The parameters of the simulation.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`isPlaying`}</strong><br />{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the simulation is running or not.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`results`}</strong><br />{`any`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Is updated each time the simulation finishes, and contains information on the past runs.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The difference between `}<inlineCode parentName="p">{`data`}</inlineCode>{` and `}<inlineCode parentName="p">{`params`}</inlineCode>{` is that `}<inlineCode parentName="p">{`data`}</inlineCode>{` is being updated at each simulation tick, without user intervention, through the `}<inlineCode parentName="p">{`updateData`}</inlineCode>{` function, whereas `}<inlineCode parentName="p">{`params`}</inlineCode>{` is only modified when the user interacts with the `}<a parentName="p" {...{
        "href": "/react-sim/controls"
      }}>{`controls`}</a>{`.`}</p>
    <p>{`The built-in parameters are:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`delay`}</strong><br />{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`delay between animation refreshes in miliseconds.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`maxTime`}</strong><br />{`integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the value of `}<inlineCode parentName="td">{`tick`}</inlineCode>{` at which the animation stops.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`minTime`}</strong><br />{`integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the value of `}<inlineCode parentName="td">{`tick`}</inlineCode>{` when the animation starts.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`ticksPerAnimation`}</strong><br />{`integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the number of simulation ticks per animation refresh. If more than one, the simulation will update several times before it's rendered again.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      